import Layout from '@/layouts/BasicLayout/index.vue'
import type { RouteRecordRaw } from 'vue-router'

const vairety: RouteRecordRaw = {
  path: '/variety',
  name: 'Variety',
  redirect: '/variety/management',
  component: Layout,
  meta: {
    title: '申报管理',
    icon: 'apply|svg'
  },
  children: [
    {
      path: 'catalog',
      name: 'PreferredCatalogManagement',
      component: () => import('@/views/PreferredCatalogManagement/index.vue'),
      meta: {
        title: '品种推荐',
        menuName: '品种推荐'
      }
    },
    // 品种管理
    {
      path: 'management',
      name: 'VarietyManagement',
      component: () => import('@/views/VarietyManagement/index.vue'),
      meta: {
        title: '申报管理 ', // 有个空格 与父级区分
        showGuideIcon: true
      }
    },
    // 品种申报
    {
      path: 'declare',
      name: 'DeclareVariety',
      component: () => import('@/views/DeclareVariety/index.vue'),
      meta: {
        title: '品种申报',
        showGuideIcon: true
      }
    },
    // 空页面，挂载中台的商品详情页
    {
      path: 'product-info',
      name: 'ProductInfoManagement',
      component: () => import('@/views/components/DocumentWrapper.vue'),
      meta: {
        hidden: true,
        title: '商品资料',
        parentMenu: '/variety/management',
        replaceBack: true // 针对微应用嵌入页面额外处理：点击返回上一页，使用replace而非push
      }
    },
    // 推荐申报品种
    {
      path: 'recommend',
      name: 'VarietyRecommend',
      component: () => import('@/views/VarietyRecommend/index.vue'),
      meta: {
        hideInMenu: true,
        hideInTab: true,
        title: '推荐申报品种',
        parentMenu: '/variety/declare'
      }
    },
    // 中药报价管理
    {
      path: 'cm-quotation',
      name: 'CmQuotation',
      component: () => import('@/views/CmQuotation/index.vue'),
      meta: {
        title: '中药报价管理'
      }
    },
    // YQS合作费率
    {
      path: 'cooperation-rate',
      name: 'CooperationRate',
      component: () => import('@/views/CooperationRate/index.vue'),
      meta: {
        title: '合作费率',
        menuName: '合作费率'
      }
    },
    // 中药
    {
      path: 'cm-quality-control',
      name: 'CmQualityControl',
      component: () => import('@/views/CmQualityControl/index.vue'),
      meta: {
        title: '中药品控管理'
      }
    }
  ]
}

export default vairety
